import React from "react";
import { Plus, X } from "lucide-react";
import { UploadButton } from "./UploadButton";

// Generic list-of-strings editor (used for images / highlights)
export function DynamicListField({ label, items, onChange, placeholder, addLabel, testId, uploadAccept }) {
  const update = (i, val) => {
    const next = [...items];
    next[i] = val;
    onChange(next);
  };
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, ""]);

  return (
    <div>
      <label className="block text-[11px] tracking-[0.2em] uppercase text-white/50 mb-3">{label}</label>
      <div className="space-y-2">
        {items.map((val, i) => (
          <div key={i} className="flex items-center gap-2">
            <input
              value={val}
              onChange={(e) => update(i, e.target.value)}
              placeholder={placeholder}
              data-testid={`${testId}-input-${i}`}
              className="flex-1 bg-white/5 border border-white/15 px-3 py-2.5 text-sm text-white focus:border-white/50 outline-none"
            />
            {uploadAccept && (
              <UploadButton
                accept={uploadAccept}
                onUploaded={(url) => update(i, url)}
                testId={`${testId}-upload-${i}`}
              />
            )}
            <button
              type="button"
              onClick={() => remove(i)}
              data-testid={`${testId}-remove-${i}`}
              className="w-9 h-9 shrink-0 border border-white/15 hover:border-white flex items-center justify-center transition-colors"
            >
              <X size={14} strokeWidth={1.5} />
            </button>
          </div>
        ))}
      </div>
      <button
        type="button"
        onClick={add}
        data-testid={`${testId}-add`}
        className="mt-3 inline-flex items-center gap-2 text-xs tracking-[0.15em] uppercase text-white/60 hover:text-white transition-colors"
      >
        <Plus size={14} strokeWidth={1.5} /> {addLabel}
      </button>
    </div>
  );
}
